import router from '@/router';
export default {
  state: {
    estateList: [],
    repairTypeList: [], //报修类型列表
    estateDetail: {},  //工单详情
    estateAssginList: [],  //维修/分配人员
    estateFeeTypeList: [],  //费用类型
  },
  getters: {

  },
  mutations: {
    setRepairTypeList(state: any, data: any) {
      state.repairTypeList = data.map((item: any) => {
        item.name = item.itemNameCn
        item.value = item.dictItemId
        return item
      })
    },
    setEstateDetail(state: any, data: any) {
      //报修时间
      data.petitionTime = router.app.$format(
        data.petitionTime,
        'YYYY.MM.DD HH:mm:ss'
      )
      // 首次分配时间
      data.assignTime = data.assignTime ? router.app.$format(
        data.assignTime,
        'YYYY.MM.DD HH:mm:ss'
      ) : ''
      // 计划完成时间
      data.expectedTime = data.expectedTime ? router.app.$format(
        data.expectedTime,
        'YYYY.MM.DD HH:mm:ss'
      ) : ''
      // 实际完成时间
      data.maintainEndTime = data.maintainEndTime ? router.app.$format(
        data.maintainEndTime,
        'YYYY.MM.DD HH:mm:ss'
      ) : ''
      data.appraisalVoList = data.appraisalVoList ? data.appraisalVoList.map((val: any) => {
        val.gradeDes = Number(val.grade) < 3 ? '一般' : Number(val.grade) == 5 ? '非常满意' : '良好'
        return val
      }) : []
      data.operationVOList = data.operationVOList ? data.operationVOList.map((val: any) => {
        val.operationTime = val.operationTime ? router.app.$format(
          val.operationTime,
          'YYYY.MM.DD HH:mm:ss'
        ) : ''
        return val
      }) : []

      state.estateDetail = data
    },
    setEstateAssginList(state: any, data: any) {
      state.estateAssginList = data && data.map((item: any) => {
        item.name = item.accountName
        item.value = item.accountId
        return item
      })
    },
    setEstateFeeTypeList(state: any, data: any) {
      state.estateFeeTypeList = data && data.map((item: any) => {
        item.value = item.id
        return item
      })
    }
  },
  actions: {
    async getEstateList({ commit }: any, params: any) {
      const { error, success }: any = await router.app.$request('ESTATE_MAINTAIN_PAGE_LIS', params);
      return { error, success };
    },
    async getEstateRepairList({ commit }: any, params: any) {
      const { error, success }: any = await router.app.$request('ESTATE_MAINTAIN_REPAIR_LIST', params);
      if (success) {
        commit('setRepairTypeList', success.data);
      }
      return { error, success };
    },
    async getEstateDetail({ commit }: any, params: any) {
      const { error, success }: any = await router.app.$request('ESTATE_MAINTAIN_DETAIL', params);
      if (success) {
        commit('setEstateDetail', success.data);
      }
      return { error, success };
    },

    async estateMaintainAdd({ commit }: any, params: any) {
      const { error, success }: any = await router.app.$request('ESTATE_MAINTAIN_ADD', params);
      return { error, success };
    },
    async estateMaintainUrge({ commit }: any, params: any) {
      const { error, success }: any = await router.app.$request('ESTATE_MAINTAIN_URGE', params);
      return { error, success };
    },
    async estateAccountAssignList({ commit }: any, params: any) {
      const { error, success }: any = await router.app.$request('ESTATE_ACCOUNT_LISTBYFUNCTIONID', params);
      if (success) {
        commit('setEstateAssginList', success.data);
      }
      return { error, success };
    },
    async estateMaintainAssign({ commit }: any, params: any) {
      const { error, success }: any = await router.app.$request('ESTATE_MAINTAIN_ASSIGN', params);
      return { error, success };
    },
    async estateMaintainGoback({ commit }: any, params: any) {
      const { error, success }: any = await router.app.$request('ESTATE_MAINTAIN_GOBACK', params);
      return { error, success };
    },
    async estateMaintainTransfer({ commit }: any, params: any) {
      const { error, success }: any = await router.app.$request('ESTATE_MAINTAIN_TRANSFER', params);
      return { error, success };
    },
    async estateMaintainFeeTypeList({ commit }: any, params: any) {
      const { error, success }: any = await router.app.$request('ESTATE_MAINTAIN_FEETYPELIST', params);
      if (success) {
        commit('setEstateFeeTypeList', success.data);
      }
      return { error, success };
    },
    async estateMaintainComplete({ commit }: any, params: any) {
      const { error, success }: any = await router.app.$request('ESTATE_MAINTAIN_COMPLETE', params);
      return { error, success };
    },
    async estateMaintainFeeitemList({ commit }: any, params: any) {
      const { error, success }: any = await router.app.$request('ESTATE_MAINTAIN_FEEITEMLIST', params);
      return { error, success };
    },
    async estateUrgeDetail({ commit }: any, params: any) {
      const { error, success }: any = await router.app.$request('REPAIR_URGE_INFO', params);
      return { error, success };
    },

  }
}